import Vue from 'vue'
import Vuex from 'vuex'
import Jwtdecode from 'jwt-decode'
import Axios from 'axios'
import APIService from '@/services/APIService'
// import VuexPersistence from 'vuex-persist'
import VuexPersistence from 'vuex-persist/dist/umd'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage
})

export default new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    betgame: -1,
    betgameData: null,
    competition: -1,
    competitionData: -1,
    user: null,
    apiUrl: null,
    token: null,
    rankings: [],
    totalRankings: [],
    users: [],
    questions: [],
    solutions: null,
    questioncount: 0,
    matchday: -1,
    usercount: 0,
    authoredBetgames: [],
    ownedBetgames: [],
    userStatistics: [],
    registrationsByDate: [],
    competitionTeams: [],
    betgameSlides: [],
    betgameAds: [],
    tournamentMatches: [],
    matches: [],
    currentSeason: { id: 16, name: '2025/26', is_current: true },
    userBetgamePoints: []
  },
  mutations: {
    SET_TOTAL_RANKINGS (state, data) {
      state.totalRankings = data
    },
    SET_USER_BETGAME_POINTS (state, data) {
      state.userBetgamePoints = data
    },
    UPDATE_USER_BETGAME_POINTS (state, data) {
      const oldData = state.userBetgamePoints.filter(p => p.fk_user === data.fk_user && p.fk_betgame === data.fk_betgame)
      if (oldData != null && oldData.length === 1) {
        oldData[0].points = data.points
      }
      state.userBetgamePoints = state.userBetgamePoints.filter(function (item) {
        return true
      })
    },
    SET_SOLUTIONS (state, data) {
      state.solutions = data
    },
    SET_SCHEDULE (state, scheduleData) {
      state.matches = scheduleData
    },
    SET_TOURNAMENT_MATCHES (state, data) {
      state.tournamentMatches = data
    },
    UPDATE_BETGAME_SLIDE_IMAGE (state, id, image) {
      const newSlides = []
      for (var i in this.betgameSlides) {
        const s = this.betgameSlides[i]
        if (s.id === id) {
          s.image = image
          newSlides.push(s)
        } else {
          newSlides.push(s)
        }
      }
      this.betgameSlides = newSlides
    },
    UPDATE_BETGAME_AD_IMAGE (state, id, image) {
      const newAds = []
      for (var i in this.betgameAds) {
        const a = this.betgameAds[i]
        if (a.id === id) {
          a.image = image
          newAds.push(a)
        } else {
          newAds.push(a)
        }
      }
      this.betgameAds = newAds
    },
    UPDATE_BETGAME_SLIDE (state, data) {
      const newSlides = []
      for (var i in this.betgameSlides) {
        const s = this.betgameSlides[i]
        if (s.id === data.id) {
          newSlides.push(data)
        } else {
          newSlides.push(s)
        }
      }
      this.betgameSlides = newSlides
    },
    UPDATE_BETGAME_AD (state, data) {
      const newAds = []
      for (var i in this.betgameAds) {
        const a = this.betgameAds[i]
        if (a.id === data.id) {
          newAds.push(data)
        } else {
          newAds.push(a)
        }
      }
      this.betgameAds = newAds
    },
    SET_COMPETITION_DATA (state, data) {
      state.competitionData = data
    },
    SET_BETGAME_SLIDES (state, data) {
      state.betgameSlides = data
    },
    SET_BETGAME_ADS (state, data) {
      state.betgameAds = data
    },
    SET_BETGAME_ICON (state, icon) {
      state.betgameData.icon = icon
    },
    SET_COMPETITION_TEAMS (state, teams) {
      var temp = []
      if (teams.length > 0) {
        for (var i = 0; i < teams.length; i++) {
          const team = teams[i]
          if (team.bg_team && team.bg_team.id && !this.getters.isPlaceholderTeam(team.bg_team.id)) {
            temp.push(team)
          }
        }
      }
      state.competitionTeams = temp
    },
    SET_REGISTRATIONS_BY_DATE (state, data) {
      state.registrationsByDate = data
    },
    SET_USER_STATISTICS (state, stats) {
      state.userStatistics = stats
    },
    SET_TOKEN (state, data) {
      const payload = Jwtdecode(JSON.stringify(data))
      var token = data[0].token
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      state.token = token
      state.user = payload
      window.sessionStorage.setItem('bgbackend_token', token)
    },
    SET_TOKEN_LOCAL (state, token) {
      const payload = Jwtdecode(JSON.stringify(token))
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
      state.token = token
      state.user = payload
    },
    CLEAR_USER_DATA (state) {
      state.token = null
      state.user = null
    },
    SET_USER_COUNT (state, count) {
      state.usercount = count
    },
    SET_OWNED_BETGAMES (state, betgames) {
      state.ownedBetgames = betgames
    },
    SET_AUTHORED_BETGAMES (state, betgames) {
      state.authoredBetgames = betgames
    },
    SET_RANKINGS (state, data) {
      state.rankings = data
    },
    SET_USERS (state, users) {
      state.users = users
    },
    SET_MATCHAY (state, matchday) {
      Vue.$log.debug('store SET_MATCHAY ' + matchday)
      state.matchday = matchday
    },
    SET_BETGAME (state, betgame) {
      Vue.$log.debug('store SET_BETGAME ' + betgame)
      state.betgame = betgame
    },
    SET_COMPETITION (state, competition) {
      Vue.$log.debug('store SET_COMPETITION ' + competition)
      state.competition = competition
    },
    SET_API_URL (state, url) {
      state.apiUrl = url
    },
    UPDATE_USER (state, data) {
      Vue.$log.debug('UPDATE_USER ' + data.id)
      const result = state.users.filter(user => user.id === data.id)
      if (result.length === 1) {
        var u = result[0]
        u.email = data.content.email
        u.nickname = data.content.nickname
        u.status = data.content.status
        u.source = data.content.source
        Vue.$log.debug('UPDATE_USER ok ' + JSON.stringify(u))
      }
    },
    ADD_USER (state, user) {
      Vue.$log.debug('ADD_USER ' + JSON.stringify(user))
      state.users.push(user)
    },
    SET_BETGAME_DATA (state, data) {
      state.betgameData = data
    },
    SET_QUESTIONS (state, data) {
      for (var i = 0; i < data.length; i++) {
        var d = data[i]
        if (d.type === 'TEAM') {
          if (d.options !== null && d.options !== undefined) {
            try {
              d.optionsJSON = JSON.parse(d.options.replace(/^\s+|\s+$/g, ''))
              d.optionsJSON.sort(function (a, b) {
                var x = a.name < b.name ? -1 : 1
                return x
              })
            } catch (e) {
              d.optionsJSON = []
            }
          } else {
            d.optionsJSON = []
          }
        }
        data[i] = d
      }
      state.questions = data
    },
    SET_QUESTION_COUNT (state, count) {
      state.questioncount = count
    }
  },
  actions: {
    fetchSchedule ({ commit }, leagueId) {
      Vue.$log.debug('fetchSchedule leagueId ' + leagueId)
      Vue.$log.debug('fetchSchedule this.state.currentSeason ' + JSON.stringify(this.state.currentSeason))
      APIService.getSchedule(leagueId, this.state.currentSeason.id)
        .then(response => {
          commit('SET_SCHEDULE', response.data)
        })
        .catch(error => {
          Vue.$log.debug('fetchSchedule error ' + error)
        })
    },
    fetchTournamentMatches ({ commit }, competition) {
      return new Promise((resolve, reject) => {
        APIService.fetchTournamentMatches(competition)
          .then(response => {
            commit('SET_TOURNAMENT_MATCHES', response.data)
            resolve(response.data)
          })
          .catch(error => {
            Vue.$log.debug('fetchTournamentMatches error ' + error)
            reject(error)
          })
      })
    },
    fetchBetgameSlides ({ commit }, betgame) {
      APIService.getBetgameSlides(betgame)
        .then(response => {
          Vue.$log.debug('fetchBetgameSlides ' + JSON.stringify(response.data))
          commit('SET_BETGAME_SLIDES', response.data)
        })
        .catch(error => {
          Vue.$log.error(error)
        })
    },
    patchBetgameSlides ({ commit }, params) {
      Vue.$log.debug('patchBetgameSlides ' + JSON.stringify(params))
      APIService.patchBetgameSlide(params.id, params)
        .then(function (response) {
          Vue.$log.debug('patchBetgameSlides ' + JSON.stringify(response.data))
          commit('UPDATE_BETGAME_SLIDE', params)
        })
        .catch(function (error) {
          Vue.$log.debug('store patchBetgameSlides catch ' + error)
        })
        .finally(function () {
          Vue.$log.debug('store patchBetgameSlides finally ')
        })
    },
    fetchBetgameAds ({ commit }, betgame) {
      APIService.getBetgameAds(betgame)
        .then(response => {
          Vue.$log.debug('fetchBetgameAds ' + JSON.stringify(response.data))
          var betgameAds = []
          for (var i in response.data) {
            const ad = response.data[i]
            ad.positionName = ad.position === 1 ? 'Startseite/Dashboard' : ''
            betgameAds.push(ad)
          }
          commit('SET_BETGAME_ADS', betgameAds)
        })
        .catch(error => {
          Vue.$log.error(error)
        })
    },
    patchBetgameAd ({ commit }, params) {
      Vue.$log.debug('patchBetgameAd ' + JSON.stringify(params))
      APIService.patchBetgameAd(params.id, params)
        .then(function (response) {
          Vue.$log.debug('patchBetgameAd ' + JSON.stringify(response.data))
          commit('UPDATE_BETGAME_AD', params)
        })
        .catch(function (error) {
          Vue.$log.debug('store patchBetgameAd catch ' + error)
        })
        .finally(function () {
          Vue.$log.debug('store patchBetgameAd finally ')
        })
    },
    fetchRegistrationsByDate ({ commit }, betgame) {
      APIService.getRegistrationsByDate(betgame).then(response => {
        Vue.$log.debug(JSON.stringify(response.data))
        if (response.data.length > 0) {
          commit('SET_REGISTRATIONS_BY_DATE', response.data)
        } else {
          Vue.$log.debug('fetchRegistrationsByDate error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    fetchUserStatistics ({ commit }, betgame) {
      APIService.getUserStatistics(betgame).then(response => {
        Vue.$log.debug(JSON.stringify(response.data))
        if (response.data.length > 0) {
          commit('SET_USER_STATISTICS', response.data)
        } else {
          Vue.$log.debug('fetchUserStatistics error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    fetchBetgame ({ commit }, id) {
      APIService.getBetgame(id).then(response => {
        if (response.data.length > 0) {
          const bg = response.data[0]
          commit('SET_BETGAME_DATA', bg)
        } else {
          Vue.$log.debug('fetchBetgame error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    setApiUrl ({ commit }, url) {
      commit('SET_API_URL', url)
    },
    setBetgame ({ commit }, betgame) {
      Vue.$log.debug('store setBetgame ' + betgame)
      commit('SET_BETGAME', betgame)
      commit('SET_USERS', [])
      commit('SET_RANKINGS', [])
      commit('SET_TOTAL_RANKINGS', [])
      commit('SET_QUESTIONS', [])
      commit('SET_SOLUTIONS', [])
      commit('SET_REGISTRATIONS_BY_DATE', [])
      commit('SET_USER_STATISTICS', [])
      // get new token - login with new betgame
    },
    setCompetition ({ commit }, competition) {
      Vue.$log.debug('store setCompetition ' + competition)
      commit('SET_COMPETITION', competition)
    },
    setMatchday ({ commit }, matchday) {
      Vue.$log.debug('store setMatchday ' + matchday)
      commit('SET_MATCHAY', matchday)
    },
    setToken ({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    setDefaultValues ({ commit }, values) {
      commit('SET_BETGAME', values.betgame)
      commit('SET_COMPETITION', values.competition)
      commit('SET_MATCHAY', values.matchday)
    },
    loadAuthor ({ commit }, user) {
      APIService.getAuthor(user).then(response => {
        Vue.$log.debug('loadAuthor ' + JSON.stringify(response.data))
        if (response.data.length > 0) {
          const author = response.data[0]
          commit('SET_BETGAME', author.fk_betgame)
        } else {
          Vue.$log.debug('loadAuthor error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    loadCompetition ({ commit }, betgame) {
      Vue.$log.debug('loadCompetition ' + betgame)
      APIService.getBetgameCompetition(betgame).then(response => {
        Vue.$log.debug('loadCompetition ' + JSON.stringify(response.data))
        if (response.data.length > 0) {
          const bc = response.data[0]
          commit('SET_COMPETITION', bc.fk_competition)
        } else {
          Vue.$log.debug('loadCompetition error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    loadCompetitionData ({ commit }, competition) {
      Vue.$log.debug('loadCompetitionData ' + competition)
      APIService.getCompetition(competition).then(response => {
        Vue.$log.debug('loadCompetitionData ' + JSON.stringify(response.data))
        commit('SET_COMPETITION_DATA', response.data[0])
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    loadLastMatchday ({ commit }, competition) {
      Vue.$log.debug('loadLastMatchday ' + competition)
      APIService.getLastMatchday(competition).then(response => {
        Vue.$log.debug('loadLastMatchday ' + JSON.stringify(response.data))
        if (response.data.length > 0) {
          const md = response.data[0]
          commit('SET_MATCHAY', md.matchday)
        } else {
          Vue.$log.debug('loadLastMatchday error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    fetchBetgameCompetition ({ commit }, betgame) {
      APIService.getBetgameCompetition(betgame).then(response => {
        Vue.$log.debug('loadCompetition ' + JSON.stringify(response.data))
        if (response.data.length > 0) {
          const bc = response.data[0]
          commit('SET_COMPETITION', bc.fk_competition)
        } else {
          Vue.$log.debug('loadCompetition error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    fetchMatchdayRankings ({ commit }, pamameters) {
      APIService.getMatchdayRanking(pamameters.fk_betgame, pamameters.fk_competition, pamameters.matchday, 50)
        .then(response => {
          if (response.data.length) {
            commit('SET_RANKINGS', response.data)
          }
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    fetchLastMatchday ({ commit }, competition) {
      APIService.getLastMatchday(competition).then(response => {
        Vue.$log.debug('loadLastMatchday ' + JSON.stringify(response.data))
        if (response.data.length > 0) {
          const md = response.data[0]
          commit('SET_MATCHAY', md.matchday)
        } else {
          Vue.$log.debug('loadLastMatchday error')
        }
      }).catch(error => {
        Vue.$log.error(error)
      })
    },
    login ({ commit }, credentials) {
      Vue.$log.debug('store.login ' + JSON.stringify(credentials))
      delete Axios.defaults.headers.common['Authorization']
      return Axios
        .post(this.state.apiUrl + '/rpc/backend_login', credentials)
        .then(({ data }) => {
          Vue.$log.debug('store.login api')
          commit('SET_TOKEN', data)
          const payload = Jwtdecode(JSON.stringify(data))
          APIService.getOwner(payload.id).then(response => {
            if (response.data.length > 0) {
              commit('SET_OWNED_BETGAMES', response.data)
              APIService.getAuthor(payload.id).then(response => {
                if (response.data.length > 0) {
                  // const author = response.data[0]
                  commit('SET_AUTHORED_BETGAMES', response.data)
                  commit('SET_BETGAME', payload.fk_betgame)
                  APIService.getBetgameCompetition(payload.fk_betgame).then(response => {
                    Vue.$log.debug('loadCompetition ' + JSON.stringify(response.data))
                    if (response.data.length > 0) {
                      const bc = response.data[0]
                      commit('SET_COMPETITION', bc.fk_competition)
                      APIService.getLastMatchday(bc.fk_competition).then(response => {
                        Vue.$log.debug('loadLastMatchday ' + JSON.stringify(response.data))
                        if (response.data.length > 0) {
                          const md = response.data[0]
                          commit('SET_MATCHAY', md.matchday)
                          APIService.getMatchdayRanking(payload.fk_betgame, bc.fk_competition, md.matchday, 50)
                            .then(response => {
                              if (response.data.length) {
                                commit('SET_RANKINGS', response.data)
                              }
                            })
                            .catch(error => {
                              Vue.$log.debug(error)
                            })
                        } else {
                          Vue.$log.debug('loadLastMatchday error')
                        }
                      }).catch(error => {
                        Vue.$log.error(error)
                      })
                    } else {
                      Vue.$log.debug('loadCompetition error')
                    }
                  }).catch(error => {
                    Vue.$log.error(error)
                  })
                } else {
                  Vue.$log.debug('loadAuthor error')
                }
              }).catch(error => {
                Vue.$log.error(error)
              })
            } else {
              commit('SET_OWNED_BETGAMES', [])
              APIService.getAuthor(payload.id).then(response => {
                if (response.data.length > 0) {
                  // const author = response.data[0]
                  commit('SET_AUTHORED_BETGAMES', response.data)
                  commit('SET_BETGAME', payload.fk_betgame)
                  APIService.getBetgameCompetition(payload.fk_betgame).then(response => {
                    Vue.$log.debug('loadCompetition ' + JSON.stringify(response.data))
                    if (response.data.length > 0) {
                      const bc = response.data[0]
                      commit('SET_COMPETITION', bc.fk_competition)
                      APIService.getLastMatchday(bc.fk_competition).then(response => {
                        Vue.$log.debug('loadLastMatchday ' + JSON.stringify(response.data))
                        if (response.data.length > 0) {
                          const md = response.data[0]
                          commit('SET_MATCHAY', md.matchday)
                          APIService.getMatchdayRanking(payload.fk_betgame, bc.fk_competition, md.matchday, 50)
                            .then(response => {
                              if (response.data.length) {
                                commit('SET_RANKINGS', response.data)
                              }
                            })
                            .catch(error => {
                              Vue.$log.debug(error)
                            })
                        } else {
                          Vue.$log.debug('loadLastMatchday error')
                        }
                      }).catch(error => {
                        Vue.$log.error(error)
                      })
                    } else {
                      Vue.$log.debug('loadCompetition error')
                    }
                  }).catch(error => {
                    Vue.$log.error(error)
                  })
                } else {
                  Vue.$log.debug('loadAuthor error')
                }
              }).catch(error => {
                Vue.$log.error(error)
              })
            }
          })
        })
    },
    loginLocal ({ commit }, token) {
      Vue.$log.debug('store.loginLocal')
      commit('SET_RANKINGS', [])
      delete Axios.defaults.headers.common['Authorization']
      return new Promise((resolve, reject) => {
        var tokenExpired = false
        try {
          const payload = Jwtdecode(token)
          const expDate = payload.exp * 1000
          if (expDate < Date.now()) {
            tokenExpired = true
          }
        } catch (e) {
          tokenExpired = token
        }
        if (!tokenExpired) {
          const payload = Jwtdecode(JSON.stringify(token))
          commit('SET_TOKEN_LOCAL', token)
          resolve(payload)
        } else {
          reject(token)
        }
      })
    },
    logout ({ commit }) {
      Vue.$log.debug('store.logout')
      commit('SET_RANKINGS', [])
      commit('SET_TOTAL_RANKINGS', [])
      commit('SET_SCHEDULE', [])
      commit('SET_TOURNAMENT_MATCHES', [])
      commit('SET_USERS', [])
      commit('SET_QUESTIONS', [])
      commit('SET_SOLUTIONS', [])
      commit('CLEAR_USER_DATA')
    },
    fetchRanking ({ commit }, params) {
      if (params.betgame < 1 && params.competition < 1) {
        commit('SET_RANKINGS', [])
        return
      }
      Vue.$log.debug('fetchRanking ' + params.betgame + ' - ' + params.competition + ' - ' + params.matchday)
      APIService.getMatchdayRanking(params.betgame, params.competition, params.matchday, 50)
        .then(response => {
          if (response.data.length) {
            commit('SET_RANKINGS', response.data)
          } else {
            commit('SET_RANKINGS', [])
          }
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    fetchUsers ({ commit }, params) {
      APIService.getUsers(params.betgame, params.offset, params.limit)
        .then(response => {
          const contentrange = response.headers['content-range']
          if (contentrange !== undefined) {
            const split = contentrange.split('/')
            if (split.length === 2) {
              commit('SET_USER_COUNT', parseInt(split[1]))
            }
          }
          Vue.$log.debug('SET_USERS ' + JSON.stringify(response.data))
          const temp = []
          for (var i = 0; i < response.data.length; i++) {
            temp.push(response.data[i].bg_user)
          }
          commit('SET_USERS', temp)
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    fetchQuestions ({ commit }, params) {
      APIService.getQuestions(params.betgame, params.offset, params.limit)
        .then(response => {
          const contentrange = response.headers['content-range']
          if (contentrange !== undefined) {
            const split = contentrange.split('/')
            if (split.length === 2) {
              commit('SET_QUESTION_COUNT', parseInt(split[1]))
            }
          }
          var questionsIDs = ''
          for (var i = 0; i < response.data.length; i++) {
            const q = response.data[i]
            if (parseInt(q.fk_betgame) === parseInt(this.state.betgame)) {
              questionsIDs += q.id + ','
            }
          }
          questionsIDs += '0'
          commit('SET_QUESTIONS', response.data)
          APIService.getSolutions(questionsIDs)
            .then(response1 => {
              commit('SET_SOLUTIONS', response1.data)
            })
            .catch(error1 => {
              Vue.$log.debug(error1)
            })
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    updateSolution ({ commit }, solution) {
      return new Promise((resolve, reject) => {
        var deleteParam = solution
        var isArray = false
        if (Array.isArray(solution)) {
          deleteParam = solution[0]
          isArray = true
        }
        const solutions = this.state.solutions.filter(s => s.fk_question !== deleteParam.fk_question)
        APIService.deleteSolutions(deleteParam)
          .then(function (response) {
            return new Promise((resolve, reject) => {
              APIService.postSolution(solution)
                .then(function (response) {
                  if (isArray) {
                    solutions.push(...solution)
                  } else {
                    solutions.push(solution)
                  }
                  commit('SET_SOLUTIONS', solutions)
                  resolve(response)
                })
                .catch(function (error) {
                  reject(error)
                })
            })
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    requestPasswordReset ({ commit }, data) {
      APIService.requestPasswordReset(data)
        .then(response => {
          Vue.$log.debug(response)
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    resendValidationEmail ({ commit }, data) {
      APIService.resendValidationEmail(data)
        .then(response => {
          Vue.$log.debug(response)
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    deleteUser  ({ commit }, data) {
      APIService.deleteUser(data)
        .then(function (response) {
          Vue.$log.debug('deleted user ' + data)
        })
        .catch(function (error) {
          Vue.$log.error('Error in deleteUser: ' + error)
        })
        .finally(function () {
          // always executed
        })
      /*
      return Axios
        .post(this.state.apiUrl + '/rpc/backend_delete_account', JSON.stringify(data))
        .then(({ result }) => {
          Vue.$log.debug('deleted user ' + data)
        }).catch(error => {
          Vue.$log.error('Error in deleteUser: ' + error)
        })
       */
    },
    updateUser  ({ commit }, data) {
      APIService.patchUser(data.id, data.content)
        .then(function (response) {
          commit('UPDATE_USER', data)
        })
        .catch(function (error) {
          // handle error
          Vue.$log.debug(error)
        })
        .finally(function () {
          // always executed
        })
    },
    addUser  ({ commit }, data) {
      Vue.$log.debug('addUser ' + JSON.stringify(data))
      return new Promise((resolve, reject) => {
        APIService.postUser(data)
          .then(function (response) {
            // /bg_user?id=eq.9926
            const location = response.headers['location']
            var newid = 0
            try {
              newid = parseInt(location.substring(location.lastIndexOf('.') + 1))
            } catch (e) {
              Vue.$log.debug(e.toLocaleString())
            }
            data.id = newid
            if (newid > 0) {
              commit('ADD_USER', data)
              APIService.postUserBetgame(newid, data.fk_betgame)
                .then(function (response) {
                  resolve(newid)
                })
                .catch(function (error) {
                  reject(error)
                })
              var other = -1
              if (data.fk_betgame === 4002) {
                other = 4001
              } else if (data.fk_betgame === 4001) {
                other = 4002
              }
              if (other > -1) {
                APIService.postUserBetgame(newid, other)
                  .then(function (response) {
                  })
                  .catch(function (error) {
                    reject(error)
                  })
              }
            }
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    patchBetgame ({ commit }, params) {
      const d = this.state.betgameData
      APIService.patchBetgame(this.state.betgame, params)
        .then(function (response) {
          let merged = {...d, ...params}
          commit('SET_BETGAME_DATA', merged)
        })
        .catch(function (error) {
          Vue.$log.debug('store patchBetgame catch ' + error)
        })
        .finally(function () {
          Vue.$log.debug('store patchBetgame finally ')
        })
    },
    postQuestion ({ commit }, question) {
      return new Promise((resolve, reject) => {
        APIService.postQuestion(question)
          .then(function (response) {
            if (response.data.length === 1) {
              resolve(response.data[0].id)
            } else {
              reject(Error('error'))
            }
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    patchQuestion ({ commit }, question) {
      return new Promise((resolve, reject) => {
        APIService.patchQuestion(question.id, question)
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    deleteQuestion_old ({ commit }, questionId) {
      return new Promise((resolve, reject) => {
        APIService.deleteQuestion(questionId, this.state.betgame)
          .then(function (response) {
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    deleteQuestion ({ commit }, questionId) {
      const betgame = this.state.betgame
      return new Promise((resolve, reject) => {
        APIService.deleteAnswers(questionId)
          .then(function (response) {
            APIService.deleteSolutions({fk_question: questionId})
              .then(function (response) {
                APIService.deleteQuestion(questionId, betgame)
                  .then(function (response) {
                    resolve(response)
                  })
                  .catch(function (error) {
                    reject(error)
                  })
              })
              .catch(function (error) {
                reject(error)
              })
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    fetchCompetitionTeams ({ commit }, competitionId) {
      APIService.fetchCompetitionTeams(competitionId)
        .then(response => {
          commit('SET_COMPETITION_TEAMS', response.data)
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    },
    uploadBetgameIcon ({ commit }, file) {
      const config = {
        headers: {
          Authorization: 'Bearer ' + this.state.token,
          'X-BETGAME-ID': '' + this.state.betgame
        }
      }
      APIService.uploadBetgameIcon(file, config)
        .then(response => {
          Vue.$log.debug('uploadBetgameIcon ' + JSON.stringify(response))
          commit('SET_BETGAME_ICON', response.data.filename)
        })
        .catch(error => {
          Vue.$log.error(error)
        })
    },
    uploadBetgameSlide ({ commit }, params) {
      const config = {
        headers: {
          Authorization: 'Bearer ' + this.state.token,
          'X-SLIDE-ID': '' + params.slide,
          'X-BETGAME-ID': '' + this.state.betgame
        }
      }
      return new Promise((resolve, reject) => {
        APIService.uploadBetgameSlide(params.file, config)
          .then(response => {
            Vue.$log.debug('uploadBetgameSlide ' + JSON.stringify(response))
            commit('UPDATE_BETGAME_SLIDE_IMAGE', params.slide, response.data.filename)
            resolve(response.data)
          })
          .catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    uploadBetgameAd ({ commit }, params) {
      const config = {
        headers: {
          Authorization: 'Bearer ' + this.state.token,
          'X-AD-ID': '' + params.ad,
          'X-BETGAME-ID': '' + this.state.betgame
        }
      }
      return new Promise((resolve, reject) => {
        APIService.uploadBetgameAd(params.file, config)
          .then(response => {
            Vue.$log.debug('uploadBetgameAd ' + JSON.stringify(response))
            commit('UPDATE_BETGAME_AD_IMAGE', params.ad, response.data.filename)
            resolve(response.data)
          })
          .catch(error => {
            Vue.$log.error(error)
            reject(error)
          })
      })
    },
    updateUserBetgamePoints ({ commit }, data) {
      return new Promise((resolve, reject) => {
        APIService.putUserBetgamePoints(data)
          .then(function (response) {
            if (response.status >= 200 && response.status <= 204) {
              commit('UPDATE_USER_BETGAME_POINTS', data)
            }
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    deleteUserBetgamePoints ({ commit }, data) {
      return new Promise((resolve, reject) => {
        APIService.deletUserBetgamePoints(data)
          .then(function (response) {
            if (response.status >= 200 && response.status <= 204) {
              // commit('UPDATE_USER_BETGAME_POINTS', data)
            }
            resolve(response)
          })
          .catch(function (error) {
            reject(error)
          })
      })
    },
    fetcheUserBetgamePoints ({ commit }, betgameId) {
      return new Promise((resolve, reject) => {
        APIService.fetchUserBetgamePoints(betgameId)
          .then(response => {
            commit('SET_USER_BETGAME_POINTS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fetchTotalRankings ({ commit }, betgame) {
      if (betgame < 1) {
        commit('SET_TOTAL_RANKINGS', [])
        return
      }
      Vue.$log.debug('fetchTotalRankings ' + betgame)
      APIService.fetchTotalRankings(betgame)
        .then(response => {
          if (response.data.length) {
            commit('SET_TOTAL_RANKINGS', response.data)
          } else {
            commit('SET_TOTAL_RANKINGS', [])
          }
        })
        .catch(error => {
          Vue.$log.debug(error)
        })
    }
  },
  getters: {
    matchdayCount (state) {
      if (state.matches.length > 0) {
        var maxmatchday = 0
        for (var i = 0; i < state.matches.length; i++) {
          const m = state.matches[i]
          if (m.matchday > maxmatchday) {
            maxmatchday = m.matchday
          }
        }
        return maxmatchday > 0 ? maxmatchday : 34
      }
      return 34
    },
    loggedIn (state) {
      var tokenExpired = false
      if (state.token) {
        try {
          const payload = Jwtdecode(state.token)
          const expDate = payload.exp * 1000
          if (expDate < Date.now()) {
            tokenExpired = true
          }
        } catch (e) {
          tokenExpired = false
        }
      }
      return !!state.user && !!state.token && !tokenExpired
    },
    getUserById: state => id => {
      Vue.$log.debug('store.getUserById ' + id)
      if (id === 0) {
        const result = state.users.filter(user => user.id === id)
        if (result.length === 0) {
          state.users.push({
            id: 0,
            nickname: '',
            email: '',
            source: '',
            status: 'active'
          })
        } else {
          result[0].nickname = ''
          result[0].email = ''
          result[0].source = ''
          result[0].status = 'active'
        }
      }
      const result = state.users.filter(user => user.id === id)
      Vue.$log.debug(JSON.stringify(result))
      return result
    },
    getQuestionById: state => id => {
      if (id === 0) {
        const result = state.questions.filter(question => question.id === id)
        if (result.length === 0) {
          state.questions.push({
            id: 0,
            fk_betgame: state.betgame,
            question: '',
            answer: '',
            type: 'NUMBER',
            points: 0,
            answer_count: 1,
            editable_until: null
          })
        } else {
          result[0].fk_betgame = state.betgame
          result[0].question = ''
          result[0].answer = ''
          result[0].type = 'NUMBER'
          result[0].points = 0
          result[0].answer_count = 1
          result[0].editable_until = null
        }
      }
      const result = state.questions.filter(question => question.id === id)
      Vue.$log.debug('store.getQuestionById ' + id + ' --- ' + JSON.stringify(result))
      return result
    },
    isPlaceholderTeam: state => team => {
      if (team >= 817 && team <= 848) {
        return true
      }
      if (team >= 990 && team <= 995) {
        return true
      }
      if (team >= 474 && team <= 481) {
        return true
      }
      return false
    }
  }
})




// WEBPACK FOOTER //
// ./src/vuex/store.js